import { useState } from "react";

interface SwitchButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function SwitchButton({ onClick, disabled }: SwitchButtonProps) {
  const [rotated, setRotated] = useState(false);

  function handleClick() {
    if (disabled) return;
    setRotated((r) => !r);
    onClick();
  }

  return (
    <div className="-my-2 z-10 self-center flex justify-center">
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className="w-10 h-10 rounded-full border-2 border-white/15 hover:border-white/30 hover:bg-[#1e3550] flex items-center justify-center transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
        style={{ background: "#122134" }}
        aria-label="Switch input mode"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className={`text-ghost-white transition-transform duration-300 ${rotated ? "rotate-180" : ""}`}
          style={{ transition: "transform 0.3s, color 0.15s" }}
        >
          <path
            d="M9 2.5V15.5M9 2.5L5.5 6M9 2.5L12.5 6M9 15.5L5.5 12M9 15.5L12.5 12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
}
